import React from 'react';
import { Box, Button, Heading, Tag, Text } from 'grommet';
import { Edit } from 'grommet-icons';
import PropTypes from 'prop-types';
import { formatEnumLabel } from '../../helpers/formatEnumLabel';
import { formatNoteDate } from '../../helpers/formatNoteDate';
import { htmlToPlainText } from '../../helpers/htmlToPlainText';

// One contact note: subject, type label, message and created date.
// The stored HTML message is shown as plain text, one Text per line, so
// nothing is ever rendered as HTML. Pass `onEdit` to show an edit button.
export const NoteCard = ({ note, onEdit }) => {
    const { subject, type, message, createdAt } = note.attributes;
    const lines = htmlToPlainText(message).split('\n');

    return (
        <Box
            pad="small"
            gap="xsmall"
            border={{ color: 'enrich-green', size: '2px' }}
            elevation="xsmall"
            round="small"
            flex={false}>
            <Box direction="row" justify="between" align="center" gap="small">
                <Heading level="4" margin="none">
                    {subject}
                </Heading>
                <Box direction="row" align="center" gap="xsmall">
                    {type && (
                        <Tag size="xsmall" value={formatEnumLabel(type)} />
                    )}
                    {onEdit && (
                        <Button
                            a11yTitle="Edit note"
                            icon={<Edit />}
                            onClick={() => onEdit(note)}
                        />
                    )}
                </Box>
            </Box>
            <Box>
                {lines.map((line, index) => (
                    // A blank line keeps its height with a no-break space.
                    <Text key={index}>{line || ' '}</Text>
                ))}
            </Box>
            <Text size="xsmall" color="grey" alignSelf="end">
                {formatNoteDate(createdAt)}
            </Text>
        </Box>
    );
};

NoteCard.propTypes = {
    note: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        attributes: PropTypes.shape({
            subject: PropTypes.string,
            type: PropTypes.string,
            message: PropTypes.string,
            createdAt: PropTypes.string,
        }),
    }).isRequired,
    onEdit: PropTypes.func,
};
